<template>
  <v-container>
    <v-row>
      <v-btn @click="onInject">
        {{ $t("contributions.contributeForm.injectSampleData") }}
      </v-btn>
      <!-- <v-btn @click="onSubmit" :loading="loading" color="primary">Submit</v-btn> -->
    </v-row>
    <v-row>
      <h2 class="text-h3 mt-3">
        {{ $t("contributions.contributeForm.title") }}
      </h2>
    </v-row>
    <v-row>
      <v-col cols="12">
        <p class="body-1">
        {{ $t("contributions.contributeForm.description") }}
        </p>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-alert type="error" v-if="error">
          {{ $t("contributions.contributeForm.error") }} {{ error }}
        </v-alert>
        <v-alert type="success" v-if="success">
          {{ $t("contributions.contributeForm.success") }}
        </v-alert>
      </v-col>
    </v-row>
    <v-row>
      <h4 class="text-h4">
        {{ $t("contributions.contributeForm.patientDetails.title") }}
      </h4>
    </v-row>
    <v-row>
      <v-col cols="6">
        <v-text-field
          :label="$t('contributions.contributeForm.patientDetails.patientNameLabel')"
          v-model="form.patient.name"
          :disabled="buttonGetPseudonymDisabled"
        ></v-text-field>
      </v-col>
      <v-col cols="6">
        <v-text-field
          :label="$t('contributions.contributeForm.patientDetails.patientRUTLabel')"
          v-model="form.patient.rut"
          :disabled="buttonGetPseudonymDisabled"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <h4 class="text-h4">
        {{ $t("contributions.contributeForm.pathologycalDetails.title") }}
      </h4>
    </v-row>
    <v-row>
      <v-col cols="6">
        <auto-complete
          :label="$t('contributions.contributeForm.pathologycalDetails.procedureLabel')"
          code-system-id="207"
          v-model="form.pathology.sampleProcedure"
        ></auto-complete>
      </v-col>
      <v-col cols="6">
        <auto-complete
          :label="$t('contributions.contributeForm.pathologycalDetails.diagnoseLabel')"
          code-system-id="207"
          v-model="form.pathology.diagnose"
        ></auto-complete>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="6">
        <auto-complete
          :label="$t('contributions.contributeForm.pathologycalDetails.tissueTypeLabel')"
          code-system-id="207"
          v-model="form.pathology.tissueType"
        ></auto-complete>
      </v-col>
      <v-col cols="6">
        <auto-complete
          :label="$t('contributions.contributeForm.pathologycalDetails.stainingLabel')"
          code-system-id="207"
          v-model="form.pathology.staining"
        ></auto-complete>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <auto-complete
          :label="$t('contributions.contributeForm.pathologycalDetails.bodyPartLabel')"
          value-set-id="DeepPathBodySite"
          v-model="form.pathology.bodyPart"
        ></auto-complete>
      </v-col>
    </v-row>
    <v-row>
      <h4 class="text-h4">
        {{ $t("contributions.contributeForm.imageDetails.title") }}
      </h4>
    </v-row>
    <v-row>
      <v-col cols="4">
        <v-text-field
          disabled
          :label="$t('contributions.contributeForm.imageDetails.contributionDateLabel')"
          :value="form.image.dateOfContribution"
        ></v-text-field>
      </v-col>
      <v-col cols="4">
        <v-text-field
          :label="$t('contributions.contributeForm.imageDetails.creationDateLabel')"
          v-model="form.image.dateOfSlideCreation"
        ></v-text-field>
      </v-col>
      <v-col cols="4">
        <v-text-field
          :label="$t('contributions.contributeForm.imageDetails.scanningDateLabel')"
          v-model="form.image.dateOfSlideScanning"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-text-field
          :label="$t('contributions.contributeForm.imageDetails.studyIDLabel')"
          disabled
          :value="form.image.dicomStudyInstanceUid"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="6"
        ><v-text-field
          disabled
          :label="$t('contributions.contributeForm.imageDetails.mmpxLabel')"
          :value="form.image.mppX"
        ></v-text-field>
      </v-col>
      <v-col cols="6"
        ><v-text-field
          disabled
          :label="$t('contributions.contributeForm.imageDetails.mmpyLabel')"
          :value="form.image.mppY"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="6"
        ><v-text-field
          disabled
          :label="$t('contributions.contributeForm.imageDetails.manufacturerLabel')"
          :value="form.image.scanner.manufacturer"
        ></v-text-field>
      </v-col>
      <v-col cols="6">
        <auto-complete
          :label="$t('contributions.contributeForm.imageDetails.modelLabel')"
          v-model="form.image.scanner.model"
          code-system-id="207"
        ></auto-complete>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="6"
        ><v-select
          :label="$t('contributions.contributeForm.imageDetails.pixelDepthLabel')"
          :items="pixelDepthItems"
          v-model="form.image.pixelDepth"
          item-text="text"
          item-value="value"
        ></v-select>
      </v-col>
      <v-col cols="6">
        <v-text-field
          :label="$t('contributions.contributeForm.imageDetails.imageOwnerLabel')"
          disabled
          v-if="form.owner.organization"
          :value="form.owner.organization.name"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <h4 class="text-h4">
        {{ $t("contributions.contributeForm.magnifications.title") }}
      </h4>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-simple-table>
          <template v-slot:default>
            <thead>
              <tr>
                <th>{{ $t("contributions.contributeForm.magnifications.magnification") }}</th>
                <th>{{ $t("contributions.contributeForm.magnifications.dimensionX") }}</th>
                <th>{{ $t("contributions.contributeForm.magnifications.dimensionY") }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="m of form.image.magnifications" :key="m.magnification">
                <td>
                  {{ m.level }}
                </td>
                <td>
                  {{ m.dimX }}
                </td>
                <td>{{ m.dimY }}</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-col>
    </v-row>
    <v-row>
      <h4 class="text-h4">
        {{ $t("contributions.contributeForm.preview") }}
      </h4>
    </v-row>
    <v-row class="visualization mb-5">
      <v-col cols="12">
        <v-btn
          @click="visualize = true"
          v-if="!visualize"
          :disabled="this.form.image.dicomSeriesInstanceUid == null"
        >
          {{ $t("contributions.contributeForm.loadVisualization") }}
        </v-btn>
        <RawVisualization
          v-if="dcmServerUrl && visualize"
          :server-url="dcmServerUrl"
          :study-uid="form.image.dicomStudyInstanceUid"
          :series-uid="form.image.dicomSeriesInstanceUid"
          :height="500"
        ></RawVisualization>
      </v-col>
    </v-row>
    <v-row justify="end">
      <v-btn @click="onSubmit" :loading="loading" color="primary">
        {{ $t("button.submit") }}
      </v-btn>
    </v-row>
  </v-container>
</template>

<script>
import AutoComplete from "@/components/contributor/AutoComplete";
import {
  fetchOrganizationWithEndpoint,
  fetchResourceWithIdentifier
} from "@/api/fhir";
import { mapState } from "vuex";
import { storeContribution } from "@/api/data-trustee";
import { DateTime } from "luxon";
import Visualization from "@/components/slide/Visualization";
import RawVisualization from "@/components/slide/RawVisualization";
import { getPseudonym } from "@/api/data-trustee";
export default {
  data() {
    return {
      pixelDepthItems: [
        { text: "8 Bit", value: 8 },
        { text: "16 Bit", value: 16 },
        { text: "32 Bit", value: 32 }
      ],
      error: null,
      loading: false,
      success: false,
      loadingPseudonym: false,
      loadingPseudonymErrorMessage: null,
      loadingPseudonymError: true,
      dcmServerUrl: null,
      visualize: false,
      form: {
        patient: {
          name: "patient name N.N.",
          rut: "1.471.929-6",
          pseudonym: null
        },
        pathology: {
          sampleProcedure: null,
          diagnose: null,
          tissueType: null,
          staining: null,
          bodyPart: null
        },
        image: {
          pixelDepth: null,
          dateOfContribution: null,
          dateOfSlideCreation: null,
          dateOfSlideScanning: null,
          dicomStudyInstanceUid: null,
          dicomSeriesInstanceUid: null,
          mppX: null,
          mppY: null,
          scanner: {
            manufacturer: null,
            model: null
          },
          magnifications: []
        },
        owner: {
          organization: null
        }
      }
    };
  },
  computed: {
    ...mapState({
      token: state => state.authentication.keycloak.token,
      tokenParsed: state => state.authentication.keycloak.tokenParsed
    }),
    buttonGetPseudonymDisabled() {
      return this.form.patient.pseudonym !== null;
    }
  },
  methods: {
    async onSubmit() {
      this.loading = true;
      this.error = null;
      this.success = null;
      const result = await storeContribution(this.token, this.form);
      if (result.status === 400) {
        this.error = await result.json();
      }
      if (result.status === 201) {
        this.success = true;
      }
      this.loading = false;
    },
    async pseudonomifyPatient() {
      try {
        this.loadingPseudonym = true;
        const resp = await getPseudonym(this.form.patient);
        this.form.patient.pseudonym = resp;
      } catch (e) {
        this.loadingPseudonymError = true;
        this.loadingPseudonymErrorMessage = e;
      } finally {
        this.loadingPseudonym = false;
      }
    },
    onInject() {
      this.$router.replace({
        query: {
          date_dicomized: "2020-10-22",
          dicomStudyUid: "1.2.276.0.7230010.3.1.2.8323329.10.1604570805.508848",
          dicomSeriesUid:
            "1.2.276.0.7230010.3.1.3.8323329.10.1604570805.508849",
          magnifications_count: "9",
          mpp_x: "0.45641259698767683",
          mpp_y: "0.45506257110352671",
          manufacturer: "hamamatsu",
          magnifications:
            '[{"level": 1.0, "dimX": 51200, "dimY": 38144}, {"level": 2.0, "dimX": 25600, "dimY": 19072}, {"level": 4.0, "dimX": 12800, "dimY": 9536}, {"level": 8.0, "dimX": 6400, "dimY": 4768}, {"level": 16.0, "dimX": 3200, "dimY": 2384}, {"level": 32.0, "dimX": 1600, "dimY": 1192}, {"level": 64.0, "dimX": 800, "dimY": 596}, {"level": 128.0, "dimX": 400, "dimY": 298}, {"level": 256.0, "dimX": 200, "dimY": 149}]'
        }
      });
      this.parseQuery();
      this.form.pathology.sampleProcedure = "chol-mmol";
      this.form.pathology.diagnose = "chol-mmol";
      this.form.pathology.tissueType = "chol-mmol";
      this.form.pathology.staining = "chol-mmol";
      this.form.pathology.bodyPart = "61959006";
      this.form.image.scanner.model = "chol-mmol";
      this.form.image.dateOfSlideCreation = DateTime.local().toISODate();
      this.form.image.dateOfSlideScanning = DateTime.local().toISODate();
      this.form.image.pixelDepth = 16;
    },
    parseQuery() {
      const query = this.$route.query;
      this.form.image.dateOfContribution = new Date();
      this.form.image.dicomStudyInstanceUid = this.get(query, "dicomStudyUid");
      this.form.image.dicomSeriesInstanceUid = this.get(
        query,
        "dicomSeriesUid"
      );
      this.form.image.mppX = this.get(query, "mpp_x");
      this.form.image.mppY = this.get(query, "mpp_y");
      this.form.image.scanner.manufacturer = this.get(query, "manufacturer");
      // TODO sanitize magnifications string
      this.form.image.magnifications = JSON.parse(
        this.get(query, "magnifications")
      );
    },
    get(query, key) {
      return key in query ? query[key] : null;
    }
  },
  async mounted() {
    this.parseQuery();
    const searchQuery = "_include=Organization:endpoint";
    const { organization, endpoint } = await fetchOrganizationWithEndpoint(
      this.tokenParsed["organization-identifier"],
      searchQuery,
      "dicom-qido-rs"
    );
    this.form.owner.organization = organization;
    this.dcmServerUrl = endpoint.address;
  },
  components: { RawVisualization, AutoComplete }
};
</script>

<style lang="scss" scoped>
.visualization {
}
</style>
